"use client";

import { cn } from "@drpcrd/utils/shared";
import { CheckboxCheck } from "./icons/checkbox-check";

type SelectableRadioButtonProps = {
  isSelected: boolean;
  onClick?: () => void;
};

/**
 * A customizable radio button component that can be used to represent a single selection state.
 */
export const SelectableRadioButton = ({
  isSelected,
  onClick,
}: SelectableRadioButtonProps) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  if (isSelected) {
    return (
      <div
        className={cn(
          "bg-primary relative flex h-2.5 w-2.5 items-center justify-center rounded-full p-0.5",
        )}
        onClick={handleClick}
        role="radio"
        aria-checked={true}
        tabIndex={-1}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            handleClick();
            e.preventDefault();
          }
        }}
      >
        <CheckboxCheck className="h-[8px] w-[10px] object-contain" />
      </div>
    );
  }

  return (
    <div
      className={cn(
        "rounded-xs relative flex h-2.5 w-2.5 items-center justify-center rounded-full border border-neutral-900 bg-white p-0.5",
      )}
      onClick={handleClick}
      role="radio"
      aria-checked={false}
      tabIndex={-1}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          handleClick();
          e.preventDefault();
        }
      }}
    >
      <div className="h-[8px] w-[10px] object-contain"></div>
    </div>
  );
};
